module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/I58Eue/tc-custom/9781614234425.jpg?1701060574142",
      "alt": "This image is the cover for the book Haunted Marietta, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Marietta, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Highlight[s] the numerous spirits which inhabit this charming Georgia town, while also offering a glimpse into the town's non-paranormal past” ("), _c('i', [_vm._v("Newswire")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Few places have continued to grow, prosper, and maintain a small-town atmosphere and sense of history like Marietta, Georgia. Of course, a sense of community is not the only preserved presence from the past. Paranormal specialist and Marietta resident Rhetta Akamatsu combines her research with a passion for history to deliver a one-of-a-kind glimpse into the area's rich and, in some cases, undying spirit. Hear the whispers of Confederate generals still echoing in the Kolb Farm House; cozy up with the unsettled spirits of the 1848 House; meet the phantoms lurking throughout Town Square; and brush up on your local history if you dare summon the Ghosts of Marietta."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Includes photos!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “In her book, Akamatsu isn’t content to delve immediately into the paranormal, but is respectful enough of her adopted home to explore some of Marietta’s stately history first.” —"), _c('i', [_vm._v("The Atlanta Journal-Constitution")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rhetta Akamatsu\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Haunted America\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0